module.exports = __webpack_public_path__ + "static/media/la-interstate.1a5455c0.jpg";